export const TransferDirection = {
  INCOMING: "INCOMING",
  OUTGOING: "OUTGOING",
} as const;

export const WITHDRAW_REASONS = [
  "FINANCIAL_NEED",
  "INVESTMENT_GOAL_MET",
  "DISSATISFACTION_WITH_ALPACA",
  "PORTFOLIO_REBALANCING",
  "MARKET_CONDITIONS",
  "OTHER",
] as const;

export const WITHDRAW_REASONS_DETAILS_REQUIRED = [
  "DISSATISFACTION_WITH_ALPACA",
  "OTHER",
] as const;
